import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import { readStorage, writeStorage } from '@/shared/utils/storage'
import { useSessionStore } from './session'

const STORAGE_KEY = 'library-scope'

/**
 * Переключатель библиотеки в шапке (ТЗ 14.1, 18.4): «Все библиотеки» (null) или одна.
 * Выбор запоминается и сверяется со списком библиотек пользователя.
 */
export const useLibraryScope = defineStore('libraryScope', () => {
  const session = useSessionStore()
  const libraryId = ref<string | null>(readStorage(STORAGE_KEY) || null)

  function select(id: string | null): void {
    libraryId.value = id
    writeStorage(STORAGE_KEY, id ?? '')
  }

  // Пропавшая библиотека (исключили, удалили) сбрасывает выбор на «Все библиотеки».
  watch(
    () => session.user?.libraries,
    (libraries) => {
      if (
        libraries !== undefined &&
        libraryId.value !== null &&
        !libraries.some((l) => l.id === libraryId.value)
      ) {
        select(null)
      }
    },
    { immediate: true },
  )

  return { libraryId, select }
})
